import { Injectable, TemplateRef } from '@angular/core';
import { Data } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ChromeService {

    private head: BehaviorSubject<TemplateRef<any>> = new BehaviorSubject<TemplateRef<any>>(null);
    private foot: BehaviorSubject<TemplateRef<any>> = new BehaviorSubject<TemplateRef<any>>(null);
    private headContext: BehaviorSubject<Data> = new BehaviorSubject<Data>(null);
    private footContext: BehaviorSubject<Data> = new BehaviorSubject<Data>(null);
    private defaultHead: TemplateRef<any>;
    private defaultFoot: TemplateRef<any>;

    head$: Observable<TemplateRef<any>> = this.head.pipe(debounceTime(50));
    foot$: Observable<TemplateRef<any>> = this.foot.pipe(debounceTime(50));
    headContext$: Observable<Data> = this.headContext.pipe(debounceTime(50));
    footContext$: Observable<Data> = this.footContext.pipe(debounceTime(50));

    constructor() { }

    setDefaultHeader(template: TemplateRef<any>) {
        this.defaultHead = template;
        this.head.next(this.defaultHead);
    }

    setDefaultFooter(template: TemplateRef<any>) {
        this.defaultFoot = template;
        this.foot.next(this.defaultFoot);
    }

    setHeader(template: TemplateRef<any>, context?: Data) {
        this.head.next(template);
        this.headContext.next(context);
    }

    setFooter(template: TemplateRef<any>, context?: Data) {
        this.foot.next(template);
        this.footContext.next(context);
    }

    clear() {
        this.head.next(this.defaultHead);
        this.foot.next(this.defaultFoot);
    }
}
